import moment from "moment";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { API_GET } from "../../helpers/api";
import * as actions from "../actions/certificates";
import {
  GET_ACTIVE_CERTIFICATES_REQUESTED,
  GET_CANCELED_CERTIFICATES_REQUESTED,
  GET_REDEMPTION_USABLE_CERTIFICATES_REQUESTED,
  GET_SUSPENDED_CERTIFICATES_REQUESTED,
} from "../types";

function* watchGetActiveCertificates() {
  yield takeEvery(GET_ACTIVE_CERTIFICATES_REQUESTED, getActiveCertificates);
}

function* getActiveCertificates(action) {
  try {
    const resp = yield call(apiGetCertificate, action.payload);
    const items = resp.data.items.reduce((acc, value) => {
      let now = new Date();
      let durationOfUse = moment(value.productionData.expireDate).diff(
        now,
        "months"
      );
      if (durationOfUse < 0) {
        durationOfUse = 0;
      }
      acc.push({
        ...value,
        stationId: value.productionData.station.stationId,
        stationName: value.productionData.station.stationName,
        productionMonth: moment(value.productionData.term).format("M"),
        productionYear: moment(value.productionData.term).format("YYYY"),
        productionPeriod: value.productionData.term,
        durationOfUse: durationOfUse,
        localTerm: moment(value.productionData.exportedAt).format(
          "DD.MM.YYYY HH:mm"
        ),
      });
      return acc;
    }, []);
    yield put(
      actions.getActiveCertificatesSucceeded({
        items: items,
        documentCount: {
          countInPage: resp.data.documentCount.countInPage,
          totalCount: resp.data.documentCount.totalCount,
        },
        blockedDocumentCount: {
          countInPage: resp.data.blockedDocumentCount.countInPage,
          totalCount: resp.data.blockedDocumentCount.totalCount,
        },
        localTerm: moment(resp.data.exportedAt).format("DD.MM.YYYY HH:mm"),
        totalPageCount: resp.data.totalPageCount,
        totalItemCount: resp.data.totalItemCount,
      })
    );
  } catch (err) {
    yield put(actions.getActiveCertificatesFailed());
  }
}

function* watchGetSuspendedCertificates() {
  yield takeEvery(
    GET_SUSPENDED_CERTIFICATES_REQUESTED,
    getSuspendedCertificates
  );
}

function* getSuspendedCertificates(action) {
  try {
    const resp = yield call(apiGetCertificate, action.payload);
    const items = resp.data.items.reduce((acc, value) => {
      acc.push({
        ...value,
        stationId: value.productionData.station.stationId,
        stationName: value.productionData.station.stationName,
        productionMonth: moment(value.productionData.term).format("M"),
        productionYear: moment(value.productionData.term).format("YYYY"),
        productionPeriod: value.productionData.term,
        localTerm: moment(value.productionData.exportedAt).format(
          "DD.MM.YYYY HH:mm"
        ),
      });
      return acc;
    }, []);
    yield put(
      actions.getSuspendedCertificatesSucceeded({
        items: items,
        total: {
          totalItemCount: resp.data.totalItemCount,
          totalPageCount: resp.data.totalPageCount,
        },
        documentCount: {
          countInPage: resp.data.documentCount.countInPage,
          totalCount: resp.data.documentCount.totalCount,
        },
        blockedDocumentCount: {
          countInPage: resp.data.blockedDocumentCount.countInPage,
          totalCount: resp.data.blockedDocumentCount.totalCount,
        },
      })
    );
  } catch (err) {
    yield put(actions.getSuspendedCertificatesFailed());
  }
}

function* watchGetCanceledCertificates() {
  yield takeEvery(GET_CANCELED_CERTIFICATES_REQUESTED, getCanceledCertificates);
}

function* getCanceledCertificates(action) {
  try {
    const resp = yield call(apiGetCertificate, action.payload);
    const items = resp.data.items.reduce((acc, value) => {
      acc.push({
        ...value,
        stationId: value.productionData.station.stationId,
        stationName: value.productionData.station.stationName,
        productionMonth: moment(value.productionData.term).format("M"),
        productionYear: moment(value.productionData.term).format("YYYY"),
        productionPeriod: value.productionData.term,
        localTerm: moment(value.productionData.exportedAt).format(
          "DD.MM.YYYY HH:mm"
        ),
      });
      return acc;
    }, []);
    yield put(
      actions.getCanceledCertificatesSucceeded({
        items: items,
        documentCount: {
          countInPage: resp.data.documentCount.countInPage,
          totalCount: resp.data.documentCount.totalCount,
        },
        total: {
          totalItemCount: resp.data.totalItemCount,
          totalPageCount: resp.data.totalPageCount,
        },
        blockedDocumentCount: {
          countInPage: resp.data.blockedDocumentCount.countInPage,
          totalCount: resp.data.blockedDocumentCount.totalCount,
        },
      })
    );
  } catch (err) {
    yield put(actions.getCanceledCertificatesFailed());
  }
}

function* watchGetRedemptionUsableCertificates() {
  yield takeEvery(
    GET_REDEMPTION_USABLE_CERTIFICATES_REQUESTED,
    getRedemptionUsableCertificates
  );
}

function* getRedemptionUsableCertificates(action) {
  try {
    const resp = yield call(apiGetCertificate, {
      ...action.payload,
      certificateSources: ["EXCHANGE"],
    });

    const items = resp.data.items.reduce((acc, value) => {
      let now = new Date();
      let durationOfUse = moment(value.productionData.expireDate).diff(
        now,
        "months"
      );
      if (durationOfUse < 0) {
        durationOfUse = 0;
      }
      acc.push({
        ...value,
        stationId: value.productionData.station.stationId,
        stationName: value.productionData.station.stationName,
        productionMonth: moment(value.productionData.term).format("M"),
        productionYear: moment(value.productionData.term).format("YYYY"),
        productionPeriod: value.productionData.term,
        durationOfUse: durationOfUse,
        localTerm: moment(value.productionData.exportedAt).format(
          "DD.MM.YYYY HH:mm"
        ),
      });
      return acc;
    }, []);
    yield put(
      actions.getRedemptionUsableCertificatesSucceeded({
        items,
        documentCount: {
          countInPage: resp.data.documentCount.countInPage,
          totalCount: resp.data.documentCount.totalCount,
        },
        total: {
          totalItemCount: resp.data.totalItemCount,
          totalPageCount: resp.data.totalPageCount,
        },
        blockedDocumentCount: {
          countInPage: resp.data.blockedDocumentCount.countInPage,
          totalCount: resp.data.blockedDocumentCount.totalCount,
        },
      })
    );
  } catch (err) {
    yield put(actions.getRedemptionUsableCertificatesFailed());
  }
}

export default function* certificateSaga() {
  yield all([
    fork(watchGetActiveCertificates),
    fork(watchGetSuspendedCertificates),
    fork(watchGetCanceledCertificates),
    fork(watchGetRedemptionUsableCertificates),
  ]);
}

function apiGetCertificate(reqParams) {
  return API_GET("certificate", {
    organizationId: reqParams.organizationId ? reqParams.organizationId : null,
    stationId: reqParams.stationId === "-" ? null : reqParams.stationId,
    resourceType:
      reqParams.resourceType === "-" ? null : reqParams.resourceType,
    month: reqParams.month === "-" ? null : reqParams.month,
    year: reqParams.year === "-" ? null : reqParams.year,
    exportStartDateYear: reqParams.exportStartDateYear ?? null,
    exportStartDateMonth: reqParams.exportStartDateMonth ?? null,
    exportEndDateYear: reqParams.exportEndDateYear ?? null,
    exportEndDateMonth: reqParams.exportEndDateMonth ?? null,
    certificateStatus: reqParams.certificateStatus,
    certificateSources: reqParams.certificateSources
      ? reqParams.certificateSources
      : "",
    dontShowOutOfDate: reqParams.dontShowOutOfDate ? true : "",
    page: reqParams.page || 0,
    size: reqParams?.size ?? 10,
  });
}
